import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { AppBar, Toolbar, IconButton, Button } from '@material-ui/core';

import { UserContext } from '@mirinae/react-auth';

import EditorPopups from './EditorPopups';
import HeaderMenu from './HeaderMenu';
import { apiServer } from '@mirinae/shared/defines/paths';
import EditorContext from '../modules/contexts/editor';
import { useDialogContext } from '../modules/contexts/dialog';

const HeaderWrapper = styled.div`
    font-family: Roboto, Helvetica, Arial, sans-serif;
`;

const Title = styled.div`
    font-size: 13px;
    font-weight: 400;
    color: #267e7d;
    width: 100%;
    text-align: center;
`;

const EditorHeader = () => {
    const [userContext] = useContext(UserContext);
    const editor = useContext(EditorContext);
    const dialog = useDialogContext();
    editor.setDialogContext(dialog);

    return (
        <HeaderWrapper>
            <AppBar position="static" color="transparent">
                <Toolbar style={{ minHeight: '24px' }} variant="dense">
                    <HeaderMenu />
                    <Title>{`Embedded Editor v0.1.7 - ${apiServer || window.location.origin} - ${userContext.user ? userContext.user && userContext.user.email : ''}`}</Title>
                </Toolbar>
            </AppBar>
            <EditorPopups context={dialog} />
        </HeaderWrapper>
    );
};

export default EditorHeader;
